export function isHex(testString: string): boolean {
    return /^#([A-Fa-f0-9]{3}){1,2}$/.test(testString);
}

export function hexToRgba(hex: string, opacity?: number): string {
    let c;
    if (isHex(hex)) {
        c = hex.substring(1).split('');
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c = '0x' + c.join('');
        // tslint:disable-next-line:no-bitwise
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + (opacity ? opacity : 1) + ')';
    }
    throw new Error('Bad Hex');
}
